// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addCardButtonStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsAddCardButton";
import { IconWrapper } from "@insite/mobius/Icon";
import Add from "@werner/XDL/Icons/Add";
import { color } from "@werner/XDL/Utilities";
import { css } from "styled-components";

addCardButtonStyles.addCardButton = {
    variant: "primary",
    sizeVariant: "small",
    icon: {
        src: Add,
        position: "right",
    },
    css: css`
        &&&& ${IconWrapper} svg {
            color: ${color("secondary")};
            fill: ${color("secondary")};
        }
    `
};